"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var DropDownOption = function (props) {
    var getErrorClass = function () {
        return props.hasError
            ? "input-validation-error"
            : "";
    };
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { className: "step-number ".concat(props.stepNumberClass) }, props.stepNumber),
        (0, preact_1.h)("div", { className: "control" },
            (0, preact_1.h)("div", { className: "wbac-dropdown-wrapper ".concat(props.stepNumberClass, " ").concat(props.isDisabled ? "disabled" : "", " ").concat(props.showAsLabel ? "label" : "", " ").concat(getErrorClass()) },
                (0, preact_1.h)("span", { className: "display-wrapper" },
                    (0, preact_1.h)("span", { className: "display-text" }, props.value ? props.value : props.defaultText)),
                (0, preact_1.h)("div", { className: "button-wrapper" },
                    (0, preact_1.h)("div", { className: "chevron-icon" })),
                (0, preact_1.h)("select", { id: props.elementId, name: props.elementId, title: props.defaultText, className: "wbac-dropdown", "data-exclude-dropdown": true, value: props.value, onChange: function (e) {
                        return props.onChange(e.target.value);
                    }, disabled: props.isDisabled },
                    (0, preact_1.h)("option", { value: "" }, props.defaultText),
                    props.options.map(function (x) { return ((0, preact_1.h)("option", { key: x, value: x }, x)); })),
                (0, preact_1.h)("div", { className: "cover" }, ". . .")))));
};
exports.default = DropDownOption;
